import { render } from "./CIS-CTA-Primary.vue?vue&type=template&id=0eb56734"
import script from "./CIS-CTA-Primary.vue?vue&type=script&lang=js"
export * from "./CIS-CTA-Primary.vue?vue&type=script&lang=js"

import "./CIS-CTA-Primary.vue?vue&type=style&index=0&id=0eb56734&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__